import {createApi} from "@reduxjs/toolkit/query/react"
import {apiConfig} from "../../utils/api-config"
import {Device, DeviceAddResponse, DeviceStatus, ResponseDevices} from "../../types/Device"
export interface UpdateDeviceRequest {
  id: number
  name: string
  description?: string
  maker?: string
  model?: string
  device_type?: string
  branch_id?: number
  status?: string
  horizontal?: boolean
  width?: number
  height?: number
}

export const deviceApi = createApi({
  reducerPath: "deviceApi",
  baseQuery: apiConfig,
  tagTypes: ["Device"],
  endpoints: (builder) => ({
    getDeviceList: builder.query<ResponseDevices, string | undefined>({
      query: (id) => ({
        url: `devices?branch_id=${id}`
      }),
      providesTags: ["Device"]
    }),
    verifyDevice: builder.mutation<
      Device,
      {
        device_id: number
        one_time_code: string
      }
    >({
      query: (arg) => ({
        url: "/devices/verification",
        method: "POST",
        body: arg
      }),
      invalidatesTags: ["Device"]
    }),
    declineDevice: builder.mutation({
      query: (id: number) => ({
        url: `/devices/${id}/registration`,
        method: "DELETE"
      }),
      invalidatesTags: ["Device"]
    }),
    updateDevice: builder.mutation<Device, UpdateDeviceRequest>({
      query: (arg) => ({
        url: `/devices/${arg.id}`,
        method: "PATCH",
        body: arg
      }),
      invalidatesTags: ["Device"]
    }),
    updateDevicePosition: builder.mutation<
      unknown,
      {
        id: number
        position: number
      }
    >({
      query: (data) => ({
        url: `/devices/${data.id}/position/${data.position}`,
        method: "PATCH"
      }),
      invalidatesTags: ["Device"]
    }),
    deleteDevice: builder.mutation<string, number>({
      query: (id) => ({
        url: `/devices/${id}`,
        method: "DELETE"
      }),
      invalidatesTags: ["Device"]
    }),
    setPlaylistToDevice: builder.mutation<
      void,
      {
        device_id: number
        playlist_id: number
      }
    >({
      query: (data) => ({
        url: `/devices/${data.device_id}/playlist`,
        method: "PUT",
        body: {
          playlist_id: data.playlist_id
        }
      }),
      invalidatesTags: ["Device"]
    }),
    getPendingDevices: builder.query<
      DeviceAddResponse,
      DeviceStatus[]
    >({
      query: (statusList) => ({
        url: `/devices/events?statuses=${statusList.join(",")}`
      }),
      providesTags: ["Device"]
    })
  })
})

export const {
  useGetDeviceListQuery,
  useVerifyDeviceMutation,
  useUpdateDeviceMutation,
  useDeleteDeviceMutation,
  useSetPlaylistToDeviceMutation,
  useUpdateDevicePositionMutation,
  useGetPendingDevicesQuery,
  useDeclineDeviceMutation
} = deviceApi
